(($) => {
    const mount = document.getElementById('map__mount')
    const infowindow = []

    let map

    if (mount) {
        // get variables from html
        const mountUrl = mount.dataset.url

        let centerLat = parseFloat(document.getElementById('map__center-lat').getAttribute('name'))
        let centerLng = parseFloat(document.getElementById('map__center-long').getAttribute('name'))
        let zoom = parseInt(document.getElementById('map__zoom').getAttribute('name'))
        const locations = document.getElementById('map__locations').getAttribute('name').split('[*]')

        if (centerLat === '')
            centerLat = 39.3999

        if (centerLng === '')
            centerLng = 3.2245

        if (zoom === '')
            zoom = 3

        $(document).ready(function () {
            function initMap () {
                map = new window.google.maps.Map(mount, {
                    center: { lat: centerLat, lng: centerLng },
                    zoom: zoom
                })

                for (let i = 0; i < locations.length; i++) {
                    const locationInfo = locations[i].split(',,,')

                    const position = new window.google.maps
                        .LatLng(locationInfo[0], locationInfo[1])

                    // create new popup info window
                    const wrapper = document.createElement('div')
                    wrapper.classList.add('map__info-wrapper')

                    if (locationInfo[5] !== '') {
                        const image = document.createElement('div')
                        image.classList.add('map__info-image')
                        image.style.backgroundImage = 'url(' + locationInfo[5] + ')'
                        wrapper.appendChild(image)
                    }

                    const title = document.createElement('h4')
                    title.classList.add('map__info-title')
                    title.innerHTML = locationInfo[2]
                    wrapper.appendChild(title)

                    const desc = document.createElement('p')
                    desc.classList.add('map__info-desc')
                    desc.innerHTML = locationInfo[3]
                    wrapper.appendChild(desc)

                    const link = document.createElement('a')
                    link.classList.add('map__info-link')
                    link.setAttribute('href', locationInfo[4])

                    if (locationInfo[6] === 'external')
                        link.setAttribute('target', '_blank')

                    wrapper.appendChild(link)

                    const markerIcon = {
                        url: mountUrl + 'assets/images/map-marker.svg',
                        scaledSize: new window.google.maps.Size(25, 25)
                    }

                    const marker = new window.google.maps.Marker({
                        position: position,
                        map: map,
                        optimized: false,
                        title: locationInfo[2],
                        icon: markerIcon
                    })

                    infowindow[i] = new window.google.maps.InfoWindow({
                        content: wrapper
                    })

                    marker.addListener('click', function () {
                        infowindow.map(i => {
                            i.close()
                        })

                        infowindow[i].open(map, marker)
                    })
                }

                window.google.maps.event.addListener(map, 'click', function (event) {
                    infowindow.map(i => {
                        i.close()
                    })
                })
            }

            initMap()
        })

        const list = document.getElementsByClassName('map-list__list')[0]
        const expand = document.getElementsByClassName('map-list__expand')[0]

        expand.addEventListener('click', () => {
            if (list.classList.contains('active')) {
                list.classList.remove('active')
                list.setAttribute('aria-hidden', 'true')
                expand.setAttribute('aria-expanded', 'false')
            }
            else {
                list.classList.add('active')
                list.setAttribute('aria-hidden', 'false')
                expand.setAttribute('aria-expanded', 'true')
            }
        })

        expand.addEventListener('keypress', (e) => {
            if (e.charCode === 13)
                if (list.classList.contains('active')) {
                    list.classList.remove('active')
                    list.setAttribute('aria-hidden', 'true')
                    expand.setAttribute('aria-expanded', 'false')
                }
                else {
                    list.classList.add('active')
                    list.setAttribute('aria-hidden', 'false')
                    expand.setAttribute('aria-expanded', 'true')
                }
        })
    }
})(window.jQuery)
